import { render, staticRenderFns } from "./PageContainerFooter.vue?vue&type=template&id=6fd74563&scoped=true&"
import script from "./PageContainerFooter.vue?vue&type=script&lang=js&"
export * from "./PageContainerFooter.vue?vue&type=script&lang=js&"
import style0 from "./PageContainerFooter.vue?vue&type=style&index=0&id=6fd74563&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd74563",
  null
  
)

export default component.exports